<template>
	<TabWrapper @save="submit" @change="change" @deploy:preview="$emit('deploy:preview')"
							@deploy:live="$emit('deploy:live')">
		<v-container fluid>
			<v-row>
				<!-- ZONE LEFT NAVIGATION (ZONE LIST) -->
				<v-col cols="12" lg="4" style="padding:0;" ref="zoneList">
					<div v-if="$vuetify.breakpoint.lgAndUp">
						<div class="d-flex justify-space-between">
							<Button v-if="!readOnly" icon="mdi-plus" :color="ada.blue" class="mx-3 mb-3"
											@click="showAddZoneDialog = true">Zone Hinzufügen
							</Button>
							<TooltipIcon :color="ada.darkGrey"
													 @click="toggleZoneListWidth"
													 :tooltip="'Liste '+ (expandList ?'verkleinern':'erweitern')">
								{{ expandList ? 'mdi-arrow-collapse-horizontal' : 'mdi-arrow-expand-horizontal' }}
							</TooltipIcon>
						</div>
						<Input v-model="search"
									 class="mx-4 mb-4"
									 label="Suche"
									 :hideDetails="true"
									 append-icon="mdi-magnify"
						></Input>
						<List>
							<v-list-item v-for="(item, i) in zones" :key="i" @click="setSelectedZone(item)"
													 :class="active(item)">
								<v-list-item-content>
									<v-list-item-title class="font-weight-regular"
																		 :title="item.Name.length > 55 ? item.zone_name || item.Name : ''">
										<!-- nosemgrep: javascript.vue.security.audit.xss.templates.avoid-v-html.avoid-v-html -->
										<span v-html="item.Name"></span>
									</v-list-item-title>
								</v-list-item-content>
								<v-list-item-icon title="Zone löschen" v-if="!readOnly">
									<v-icon class="deleteIcon" :color="ada.grey" right @click.stop="deleteZone(item)">
										mdi-delete
									</v-icon>
								</v-list-item-icon>
							</v-list-item>
						</List>
					</div>
					<div v-else>
						<v-autocomplete
							class="mx-3"
							:items="zones"
							label="Zonen"
							item-text="Name"
							item-value="Name"
							:readonly="readOnly"
							:color="ada.blue"
							flat
							return-object
							no-data-text="Keine Daten"
							v-model="selectedZone"
						>
							<template v-slot:selection="data">
								{{ data.item.zone_name || data.item.Name }}
							</template>
							<template v-slot:item="data">
								<span>{{ data.item.Name }}</span>
							</template>
							<template v-slot:append-outer="">
								<Button v-if="$vuetify.breakpoint.mdAndUp && !readOnly" class="ml-2"
												icon="mdi-plus" @click="showAddZoneDialog = true"
												:color="ada.blue">Zone hinzufügen
								</Button>
								<TooltipIcon v-else :color="ada.blue" :fab="true"
														 @click="showAddZoneDialog = true"
														 tooltip="Zone hinzufügen">mdi-plus
								</TooltipIcon>
							</template>
						</v-autocomplete>
					</div>
				</v-col>

				<!-- ZONE CONTENT (RIGHT) -->
				<v-col cols="12" lg="8" ref="zoneContent">
					<div class="borderContainer ml-lg-4" :class="[$vuetify.breakpoint.name]">
						<transition name="fade" mode="out-in">
							<!-- LOADER -->
							<div v-if="zonesLoading || selectedZone === null" :key="0"
									 class="d-flex justify-center align-center"
									 style="width:100%;height: 350px;">
								<v-progress-circular v-if="zonesLoading" :size="50" :color="ada.pink" indeterminate
								></v-progress-circular>
								<div v-if="selectedZone === null" class="noSiteSelected">
									Bitte eine Zone zum Bearbeiten auswählen.
								</div>
							</div>
							<!-- CONTENT -->
							<div v-else :key="1" class="px-lg-6">
								<v-row>
									<v-col cols="12" lg="7">
										<div style="max-width:400px">
											<Input v-model="zone_name" label="Zonenbezeichnung"
														 :disabled="true" hide-details></Input>
										</div>
									</v-col>
									<v-col cols="12" lg="5">
										<Toggle
											v-model="oop"
											label="Out of Page Slot"
											:disabled="readOnly"
											hide-details
										>
										</Toggle>
										<Toggle
											v-model="interstitial"
											label="Mobile / Web Interstitial Slot"
											:disabled="readOnly"
											hide-details
										></Toggle>
									</v-col>
								</v-row>

								<v-row no-gutters>
									<v-col>
										<Datatable :headers="tableHeaders" :items="positions"
															 @click:row="openActionDialog($event, 'edit')"
															 @click:reset="openActionDialog($event, 'reset')"
															 @click:edit="openActionDialog($event, 'edit')"
															 @click:delete="openActionDialog($event, 'delete')"
															 title="Positionen" :items-per-page="-1"
															 itemSlot="item:Status"
										>
											<template #top>
												<div v-if="!readOnly && zoneDetails.Zone.Name === '_default'">
													<TooltipIcon :color="ada.blue" :fab="true"
																			 @click="openActionDialog(null, 'edit')"
																			 tooltip="Position hinzufügen">mdi-plus
													</TooltipIcon>
												</div>
											</template>
											<template #item:Status="item">
												<v-icon :color="(item.Status === 1 ? 'green' : 'red')">
													{{ item.Status === 1 ? 'mdi-check' : 'mdi-close' }}
												</v-icon>
												<TooltipIcon
													v-if="typeof item.Override !== 'undefined' && !item.Override"
													tooltip="Wird von der Erbfolge ausgeschlossen" xsmall
													color="red">
													mdi-exclamation-thick
												</TooltipIcon>
											</template>
										</Datatable>
									</v-col>
								</v-row>
							</div>
						</transition>
					</div>
				</v-col>
			</v-row>
		</v-container>
		<AddZoneDialog v-model="showAddZoneDialog"></AddZoneDialog>
		<DeleteZoneDialog v-model="showDeleteZoneDialog" :data="zoneToDelete"></DeleteZoneDialog>
		<PositionsDialog v-model="showPositionsDialog" :position="positionToEdit"
										 :readOnly="readOnly"></PositionsDialog>
		<ResetPositionDialog v-model="showResetPositionDialog" :position="positionToEdit"></ResetPositionDialog>
		<DeletePositionDialog v-model="showDeletePositionDialog" :position="positionToEdit"></DeletePositionDialog>
	</TabWrapper>
</template>

<script>
import TabWrapper from "./TabWrapper";
import Input from "../../../components/Inputs/Input";
import ada from "../../../scss/ada_colors.scss";
import Button from "../../../components/buttons/Button";
import TooltipIcon from "../../../components/TooltipIcon";
import Toggle from "../../../components/buttons/Toggle";
import AddZoneDialog from "../Dialogs/AddZoneDialog";
import DeleteZoneDialog from "../Dialogs/DeleteZoneDialog";
import PositionsDialog from "../Dialogs/PositionsDialog";
import DeletePositionDialog from "../Dialogs/DeletePositionDialog";
import Utils from "../../../scripts/Utils";
import List from "../../../components/List";
import Datatable from "../../../components/Tables/Datatable";
import ResetPositionDialog from "../Dialogs/ResetPositionDialog";

export default {
	name: "Zones",
	props: ['readOnly'],
	components: {
		ResetPositionDialog,
		Datatable,
		List,
		DeletePositionDialog,
		PositionsDialog, DeleteZoneDialog, AddZoneDialog, Toggle, TooltipIcon, Button, Input, TabWrapper
	},
	data: () => {
		return {
			showAddZoneDialog: false,
			showDeleteZoneDialog: false,
			showPositionsDialog: false,
			showDeletePositionDialog: false,
			showResetPositionDialog: false,
			position_search: null,
			search: null,
			//selectedZone: null,
			zonesLoading: false,
			zone_name: null,
			oop: null,
			note: null,
			interstitial: null,
			positionTableHeaders: [
				{text: 'Aktiv', value: 'Status', width: '80px'},
				{text: 'Name', value: 'name'},
				{text: 'Pos', value: 'Position', width: '80px'},
				{text: 'Sizes', value: 'sizes'},
				{text: 'Erstellt am', value: 'created_at', width: '130px'},
				{text: 'Aktion', value: 'action', width: '110px', sortable: false},
			],
			ignoreUpdate: false,
			zoneToDelete: null,
			positionToEdit: null,
			expandList: true,
			ada
		}
	},
	mounted() {
		//this.$store.commit('zones/resetZoneStore');
		this.init();
		this.$emit('activeComponent', this);
	},
	computed: {
		vuexState() {
			return this.$store.state.display;
		},
		selectedZone() {
			return this.$store.state.zones.selectedZone;
		},
		siteDetails() {
			return this.vuexState.siteDetails;
		},
		zones() {
			if (this.siteDetails) {
				if (this.search && this.search !== '' && this.$vuetify.breakpoint.lgAndUp) {
					return this.siteDetails.Zones.filter(x => Utils.parseZoneName(x.Name).indexOf(this.search) !== -1);
				} else {
					return this.siteDetails.Zones;
				}
			}
			return [];
		},
		zoneDetails() {
			return this.$store.state.zones.zoneDetails;
		},
		selectedSitetype() {
			return this.$store.state.display.selectedType;
		},
		positions() {
			return this.$store.getters['zones/positions'];
		},
		tableHeaders() {
			if (this.$vuetify.breakpoint.smAndDown) {
				return this.positionTableHeaders.slice(0, this.positionTableHeaders.length - 2);
			} else {
				if (this.readonly) {
					return this.positionTableHeaders.filter(x => x.value !== 'action');
				} else {
					return this.positionTableHeaders;
				}
			}
		},
		response() {
			return this.$store.state.deploy.saveManagementRes;
		}
	},
	methods: {
		init() {
			if (this.zoneDetails) {
				this.zone_name = this.zoneDetails.Zone.Name;
				this.oop = this.zoneDetails.Zone.Oop;
				this.interstitial = this.zoneDetails.Zone.Interstitial;
				//this.note = this.zoneDetails.Zone.Note ?? '';
			}
		},
		fetchZoneDetails() {
			if (this.selectedZone) {
				this.zonesLoading = true;
				this.$store.dispatch('zones/fetchZoneDetails', this.selectedZone.ZoneId).then(() => {
					this.zonesLoading = false;
				});
			}
		},
		setSelectedZone(item) {
			this.$store.commit('zones/setSelectedZone', item);
		},
		active(item) {
			if (this.selectedZone && this.selectedZone.ZoneId === item.ZoneId) {
				return 'active';
			} else {
				return ''
			}
		},
		deleteZone(item) {
			this.zoneToDelete = item;
			this.showDeleteZoneDialog = true;
		},
		openActionDialog(item, type) {
			this.positionToEdit = item;
			if (type === 'delete') {
				this.showDeletePositionDialog = true;
			} else if (type === 'edit') {
				this.showPositionsDialog = true;
			} else if (type === 'reset') {
				this.showResetPositionDialog = true;
			}
		},
		submit() {
			this.$emit('submit', this);
		},
		change(activeTab) {
			if (this.vuexState.previousTab === this.$options._componentTag) {
				this.$emit('change', this);
			} else if (activeTab === this.$options._componentTag) {
				this.$emit('activeComponent', this);
			}
		},
		dataChanged() {
			let changed = false;
			if (this.selectedZone &&
				(this.oop !== this.zoneDetails.Zone.Oop ||
					//(typeof this.zoneDetails.Zone.Note !== "undefined" && this.note !== this.zoneDetails.Zone.Note) ||
					this.interstitial !== this.zoneDetails.Zone.Interstitial)) {
				changed = true;
			}
			return changed;
		},
		getBody() {
			return {
				publisher_id: this.siteDetails.Site.PublisherId,
				site_id: this.siteDetails.Site.SiteId,
				type_id: this.siteDetails.Current.SitetypeId,
				zone_id: this.zoneDetails.Zone.ZoneId,
				ZoneName: this.zone_name,
				Oop: this.oop,
				Interstitial: this.interstitial,
				//Note: this.note,
			}
		},
		toggleZoneListWidth() {
			this.expandList = !this.expandList;
			if (this.expandList) {
				this.$refs.zoneList.classList.replace('col-lg-3', 'col-lg-4');
				this.$refs.zoneContent.classList.replace('col-lg-9', 'col-lg-8');
			} else {
				this.$refs.zoneList.classList.replace('col-lg-4', 'col-lg-3');
				this.$refs.zoneContent.classList.replace('col-lg-8', 'col-lg-9');
			}
		}
	},
	watch: {
		showDeleteZoneDialog(n) {
			if (!n) this.zoneToDelete = null;
		},
		selectedZone(value) {
			if (typeof value === "undefined" || value === null) {
				this.setSelectedZone(null);
			} else if (!this.ignoreUpdate) {
				this.fetchZoneDetails();
			} else {
				this.ignoreUpdate = false;
			}
		},
		zoneDetails() {
			if (this.zoneDetails) {
				if (this.selectedZone === null || this.selectedZone.ZoneId !== this.zoneDetails.Zone.ZoneId) {
					this.ignoreUpdate = true;
					this.setSelectedZone(this.zoneDetails.Zone);
				}
				this.init();
			} else {
				if (this.zoneDetails !== null) this.ignoreUpdate = true;
				if (this.selectedZone !== null) this.setSelectedZone(null);
			}
		},
		siteDetails() { // can't use selectedSite to watch, cause it won't react to changes -.-
			this.setSelectedZone(null);
		},
		selectedSitetype() {
			this.setSelectedZone(null);
		},
		response(n) {
			if (n.Status && this.zoneDetails && n.Zones.find(x => x.ZoneId === this.zoneDetails.Zone.ZoneId)) {
				this.$store.commit('zones/setOopIntNote', n.Zones.find(x => x.ZoneId === this.zoneDetails.Zone.ZoneId))
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.borderContainer {
	&.lg, &.xl {
		border-left: 1px solid rgba(0, 0, 0, .12);
	}

	&.xs, &.sm, &.md {
		border-top: 1px solid rgba(0, 0, 0, .12);
	}

	&.sm, &.md {
		padding-top: 24px;
	}

	&.xs {
		padding-top: 20px;
	}
}

::v-deep tbody tr {
	cursor: pointer;
}

::v-deep .v-textarea.theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state) > .v-input__control > .v-input__slot fieldset {
	color: rgb(156 156 156 / 38%) !important;
}
</style>